/* eslint-disable */
import type { CarType, EngineType, Vendor } from '../car/car_common';
import type { RateTypeV1 } from '../hotel/hotel_common';

export interface CarPref {
  /** Preferred vendors of car. */
  vendors: Vendor[];
  /** Preferred types of cars. */
  carTypes: CarType[];
  /** Preferred engine types. */
  engineTypes: EngineType[];
  /** Preferred transmission types. */
  transmissionTypes: CarPrefTransmissionType[];
  /** Preferred rate types. */
  rateTypes: RateTypeV1[];
}

export enum CarPrefTransmissionType {
  TRANSMISSION_TYPE_UNKNOWN = 0,
  MANUAL = 1,
  AUTOMATIC = 2,
  UNRECOGNIZED = -1,
}
